import { render, staticRenderFns } from "./DashboardAppointments.vue?vue&type=template&id=5cf395bc"
import script from "./DashboardAppointments.vue?vue&type=script&lang=js"
export * from "./DashboardAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports